# Sprites from anime?
import card0 from "./deck_anime/anime_0.png"
import card1 from "./deck_anime/anime_1.png"
import card2 from "./deck_anime/anime_2.png"
import card3 from "./deck_anime/anime_3.png"
import card4 from "./deck_anime/anime_4.png"
import card5 from "./deck_anime/anime_5.png"
import card6 from "./deck_anime/anime_6.png"
import card7 from "./deck_anime/anime_7.png"
import card8 from "./deck_anime/anime_8.png"
import card9 from "./deck_anime/anime_9.png"
import card10 from "./deck_anime/anime_10.png"
import card11 from "./deck_anime/anime_11.png"
import card12 from "./deck_anime/anime_12.png"
import card13 from "./deck_anime/anime_13.png"
import card14 from "./deck_anime/anime_14.png"
import card15 from "./deck_anime/anime_15.png"
import card16 from "./deck_anime/anime_16.png"
import card17 from "./deck_anime/anime_17.png"
import card18 from "./deck_anime/anime_18.png"
import card19 from "./deck_anime/anime_19.png"
import card20 from "./deck_anime/anime_20.png"
import card21 from "./deck_anime/anime_21.png"
import card22 from "./deck_anime/anime_22.png"
import card23 from "./deck_anime/anime_23.png"
import card24 from "./deck_anime/anime_24.png"
import card25 from "./deck_anime/anime_25.png"
import card26 from "./deck_anime/anime_26.png"
import card27 from "./deck_anime/anime_27.png"
import card28 from "./deck_anime/anime_28.png"
import card29 from "./deck_anime/anime_29.png"
import card30 from "./deck_anime/anime_30.png"
import card31 from "./deck_anime/anime_31.png"
import card32 from "./deck_anime/anime_32.png"
import card33 from "./deck_anime/anime_33.png"
import card34 from "./deck_anime/anime_34.png"
import card35 from "./deck_anime/anime_35.png"
import card36 from "./deck_anime/anime_36.png"
import card37 from "./deck_anime/anime_37.png"
import card38 from "./deck_anime/anime_38.png"
import card39 from "./deck_anime/anime_39.png"
import card40 from "./deck_anime/anime_40.png"
import card41 from "./deck_anime/anime_41.png"
import card42 from "./deck_anime/anime_42.png"
import card43 from "./deck_anime/anime_43.png"
import card44 from "./deck_anime/anime_44.png"
import card45 from "./deck_anime/anime_45.png"
import card46 from "./deck_anime/anime_46.png"
import card47 from "./deck_anime/anime_47.png"
import card48 from "./deck_anime/anime_48.png"
import card49 from "./deck_anime/anime_49.png"
import card50 from "./deck_anime/anime_50.png"
import card51 from "./deck_anime/anime_51.png"
import cardBack from "./deck_anime/anime_back.png"
import cardGuide from "./deck_anime/anime_guide.png"
import cardReserve from "./deck_anime/anime_reserve.png"
import cardDead from "./deck_anime/anime_dead.png"
import cardReady from "./deck_anime/anime_ready.png"

export urls = [ card0, card1, card2, card3, card4, card5, card6, card7, card8, card9,
card10, card11, card12, card13, card14, card15, card16, card17, card18,
card19, card20, card21, card22, card23, card24, card25, card26, card27,
card28, card29, card30, card31, card32, card33, card34, card35, card36,
card37, card38, card39, card40, card41, card42, card43, card44, card45,
card46, card47, card48, card49, card50, card51 ]

export other = [
  cardBack
  cardGuide
  cardReserve
  cardDead
  cardReady
]

export back = cardBack
export guide = cardGuide
export reserve = cardReserve
export dead = cardDead
export ready = cardReady
